<template lang="html">
  <fullscreen-overlay-layout
    @close="$emit('close')"
    :title="getCurrentRT.title"
  >
    <div
      style="padding: 20px;"
      :class="{ 'hidden-record': submission.is_hidden }"
    >
      <submission-card-header
        :showHeaderOptions="false"
        :showVersions="false"
        :submission="submission"
      />
      <submission-response-text
        :submission="submission"
        :disableMinimizeText="true"
      />
      <div class="start-xs">
        <span class="i" style="font-size: 12px; color: #273248;">
          {{ getPromptWordsLength }} Words
        </span>
      </div>
      <div class="ml-auto mt3 mb4 tr">
        <comments-tab
          class="br3"
          :submission="submission"
          :showComments="true"
        />
      </div>
    </div>
  </fullscreen-overlay-layout>
</template>
<script>
  import { mapGetters } from 'vuex';
  import SubmissionCardHeader from './submissionCard/cardHeader';
  import SubmissionResponseText from './submissionResponseText';
  import CommentsTab from './commentsTab';
  import FullscreenOverlayLayout from 'components/fullscreenOverlay';
  import wordCountService from '../services/wordCount/wordCount';

  export default {
    data() {
      return {
        show_all_comments: false,
      };
    },
    components: {
      SubmissionCardHeader,
      SubmissionResponseText,
      CommentsTab,
      FullscreenOverlayLayout,
    },
    computed: {
      ...mapGetters(['getOrderedSubmissions', 'getCurrentRT']),
      submissionID() {
        return this.$route.query.submissionID;
      },
      getPromptWordsLength() {
        return wordCountService.getWordCount(this.submission);
      },
      submission() {
        const foundSubmission = this.getOrderedSubmissions.find(
          (submission) => submission.id === this.submissionID
        );
        return foundSubmission || { id: null };
      },
      commentsToShow() {
        return this.submission.comments || [];
      },
    },
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// individualSubmissionOverlay.vue?1a280e40